/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { GetRoutineQueryResponse, GetRoutinePathParams, GetRoutine401, GetRoutine403, GetRoutine404 } from '../types/GetRoutine.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetRoutineUrl(id: GetRoutinePathParams['id']) {
  const res = { method: 'GET', url: `/routines/${id}` as const };
  return res;
}

/**
 * @summary Get routine by ID
 * {@link /routines/:id}
 */
export async function getRoutine(id: GetRoutinePathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetRoutineQueryResponse, ResponseErrorConfig<GetRoutine401 | GetRoutine403 | GetRoutine404>, unknown>({
    method: 'GET',
    url: getGetRoutineUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
